import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { People } from '../../reporting.type';

@Component({
    selector: 'reporting-people',
    templateUrl: './reporting-people.component.html',
    styleUrls: ['./reporting-people.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportingPeopleComponent {

   @Input() people: People;

    constructor() {}


}

